export enum AppRoutes {
	Embedded = `:env/:tenantSubdomain/embedded/:id/:layout`,
}
